export default "__VITE_ASSET__DjHx4nep__"